module.exports = __webpack_public_path__ + "assets/img/官网首页_02.d4cbbb1c.jpg";